module.exports = __webpack_public_path__ + "assets/img/capitol-news-active.76d3bff0.svg";